import * as React from "react";
import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";
import { get, post } from "../api";
import useNotify from "../notification/use_notification";

async function get_orders(all) {
  return await get(`/orders${all ? "" : "/new"}`);
}
async function complete_orders(orders) {
  return await post("/orders/complete", orders);
}

function useOrders() {
  const queryClient = useQueryClient();
  const [state, setState] = React.useState([]);
  const [all, setAll] = React.useState(false);
  const notify = useNotify();
  const oQuery = useQuery({
    queryKey: ["orders"],
    queryFn: async () => await get_orders(all),
    onSuccess: (data) => setState(data.sort((a, b) => a.order_id - b.order_id)),
    refetchInterval: 15000,
  });
  const completeOrders = async (orders) => {
    await completeOrdersMutation.mutate(orders);
  };
  const completeOrdersMutation = useMutation({
    mutationFn: complete_orders,
    onError: (error) => notify.error(error),
    onSuccess: async () => await queryClient.invalidateQueries(["orders"]),
  });
  return { state, isLoading: oQuery.isLoading, completeOrders };
}
export default useOrders;
